<div class="content">
  <div class="progress_loader"></div>
  <!-- <div class="message">
      <p class="">Loading your data...</p>
  </div> -->
</div>